<div
  class="flex justify-between items-center justify-self-center gap-2"
  [class.flex-wrap]="display() === 'bar'"
  [class.gap-y-1]="display() === 'bar'"
>
  <span class="w-16 text-right">{{ value() | appNumber: '1.2-2' }}</span>
  <span>|</span>
  <span class="text-left w-16">{{ percentage() | appNumber: '1.0-0' }}%</span>
  @switch (display()) {
    @case ('bar') {
      <app-score-bar class="w-full basis-full" [percentage]="percentage()" testId="score-bar" />
    }
    @case ('pie') {
      <div class="ml-8" [class.w-8]="!wideChart()" [class.w-14]="wideChart()">
        <p-chart type="pie" [data]="chartData()" [options]="chartOptions()" />
      </div>
    }
  }
</div>
